
$(document).ready(function(){

    $('.studio_drop_down').click(function(){
      $(this).parents('li').addClass('studio_active_drop_down');
      
    });
    $('.back_main_menu').click(function(){
      $(this).parents('li').removeClass('studio_active_drop_down');
    });
    // var options = [];
    // $('.product_variant_option').each(function(){
        
    //     var selected_variant = $(this).find('.product-section__options-values-wrapper label input:checked').val()
    //     options.push(selected_variant)
    // })
   
    // var option_1 = options[0];
    // var option_2 = options[1];
    // var qty = $('.product_variants option[data-opt1="'+option_1+'"][data-opt2="'+option_2+'"]').attr('data-qty');
        
    // if(qty <= 0)
    // {
    //     $('.sizevariant_option label input[value="'+option_1+'"]').attr('data-disabled', 'true');
    // }

  function variant_qty() {
      $('.sizevariant_option-1 label input').each(function() {
          var all_size = $(this).val();
          var qty_data = parseInt($('.product_variants option[data-opt1="' + all_size + '"]').attr('data-qty'), 10);
          
          if (qty_data <= 0) {
              $(this).attr('data-disabled', 'true');
          } else {
              $(this).removeAttr('data-disabled');
          }
      });
  }
  
  
  $('.product_variant_option .product-section__options-values-wrapper label').click(function() {
      
      setTimeout(variant_qty, 10);
  });
  
  // Initial call to variant_qty to set up initial states
  variant_qty();
  setTimeout(variant_qty, 500);

})